<template>
  <div class="container is-fullwidth">
    <div class="columns">
      <div class="column is-4 is-offset-1">
        <div class="title has-text-centered">Find Mentor</div>

        <table class="table has-background-light search-options">
          <tbody>
            <tr>
              <td class="is-vcentered is-fullheight">
                <label class="label">Search key</label>
              </td>
              <td class="is-vcentered is-fullheight">
                <div class="control is-fullwidth">
                  <input v-model="search_text" class="input" type="text" placeholder="Enter username or name..." />
                </div>
              </td>
            </tr>

            <tr>
              <td class="is-vcentered is-fullheight">
                <label class="label">Designation</label>
              </td>
              <td class="is-vcentered is-fullheight">
                <div class="select is-fullwidth">
                  <select v-model="selected_uid.designation">
                    <option value="" selected="selected">
                      Any designation
                    </option>
                    <option v-for="designation in field_options.designation" v-bind:key="designation.uid"
                      v-bind:value="designation.uid">
                      {{ designation.label }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>

            <tr>
              <td class="is-vcentered is-fullheight">
                <label class="label">Department</label>
              </td>
              <td class="is-vcentered is-fullheight">
                <div class="select is-fullwidth">
                  <select v-model="selected_uid.department">
                    <option value="" selected="selected">Any department</option>
                    <option v-for="department in field_options.department" v-bind:key="department.uid"
                      v-bind:value="department.uid">
                      {{ department.label }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>

            <tr>
              <td class="is-vcentered is-fullheight">
                <label class="label">Discipline</label>
              </td>
              <td class="is-vcentered is-fullheight">
                <div class="select is-fullwidth">
                  <select v-model="selected_uid.discipline">
                    <option value="" selected="selected">Any discipline</option>
                    <option v-for="discipline in field_options.discipline" v-bind:key="discipline.uid"
                      v-bind:value="discipline.uid">
                      {{ discipline.label }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="is-centered">
                <button class="button is-primary is-fullwidth" v-on:click="find_mentors">
                  Search
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- SEARCH RESULTS -->
      <div class="column is-offset-1 is-5">
        <div class="title has-text-centered">Search Results</div>

        <div v-if="search_results.length === 0">
          <span class="box is-centered has-text-centered has-text-weight-bold has-background-white">
            No data
          </span>
        </div>
        <div v-else class="px-3" style="max-height: min(600px, 60vh); overflow-y: auto">
          <ul>
            <li v-for="(mentor, index) in search_results" class="box py-4 my-3" v-bind:key="index">
              <div class="columns is-mobile is-vcentered">
                <div class="column">
                  <router-link v-bind:to="{
                    name: 'MentorProfilePage',
                    params: { profile_uid: mentor.uid },
                  }" class="hyperlink">
                    {{ mentor.first_name }} {{ mentor.last_name }} 
                  </router-link>
                  <br>
                    <span> {{ mentor.organization  }}</span>
                  <div class="is-italic">

                    <div v-if="mentor.isExpanded">
                    <div v-if="mentor.designation_label.length > 0">
                      <span class="has-text-weight-bold">Designation:</span>
                      <li v-for="(department, index) in mentor.designation_label" v-bind:key="index">
                        {{ department.label }}
                      </li>
                    </div>
                    <div v-if="mentor.discipline_label.length > 0">
                      <span class="has-text-weight-bold">Discipline:</span>
                      <li v-for="(discipline, index) in mentor.discipline_label" v-bind:key="index">
                        {{ discipline.label }}
                      </li>
                    </div>
                  </div>
                    <button @click="toggleContent(index)" class="button is-link is-small">
                      {{ mentor.isExpanded ? 'Less' : 'More' }}
                    </button>
                    <!-- {{ mentor.discipline_label }} -->
                  </div>
                </div>

                <div class="column is-narrow">
                  <!-- <router-link
                v-bind:to="{ name: 'LoginPage' }"
              >
                  <button
                    class="button is-primary"
                  >
                    Login to Request
                  </button>

                </router-link> -->

                </div>
              </div>
            </li>
          </ul>
        </div>
        <section class="section">
        <div class="container">
          <div class="is-flex columns is-centered ">

            <button class="button is-primary is-half m-2" v-on:click="prevPage">
              Prev
            </button>
  
            <span class="is-primary is-half m-2" v-on:click="prevPage">
              Page {{ Math.floor(offset / pageSize) + 1 }} of {{ Math.ceil(count / pageSize) }}
            </span>

            <button class="button is-primary is-half m-2" v-on:click="nextPage">
              Next
            </button>

          </div>
        </div>
      </section>
      </div>

      

      <div class="columns is-center" style="width: 100%;">

      </div>
      <!-- SEND REQUEST MODAL -->

    </div>
  </div>
  
</template>

<script>
import axios from '../api/my-axios';
import InputBox from '../components/FormHelpers/InputBox';
import FormErrors from '../components/FormHelpers/FormErrors';
import { mapState } from 'vuex';
import { PRIORITY_VALUES } from '../lib';

export default {
  components: {
    FormErrors,
    InputBox,
  },
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  data() {
    return {
      PRIORITY_VALUES,
      search_text: '',
      field_options: {
        designation: [],
        department: [],
        discipline: [],
      },
      selected_uid: {
        designation: '',
        department: '',
        discipline: '',
      },
      offset: 0,
      count: 0,
      pageSize: 5,
      show_send_request_modal: false,

      selected_mentor_index: -1,
      search_results: [], // TODO Should only consist of non-pending requests

      showLoading: true,
    };
  },
  created() {
    // TODO Try to fetch all three field options in one-go
    this.get_field_options();
  },
  methods: {
    get_field_options() {
      for (const field in this.field_options) {
        axios
          .get(`/api/mentor/${field}/`)
          .then((response) => {
            this.field_options[field] = response.data;
          })
          .catch((error) => {
            this.errors = error.response.data;
          });
      }
    },
    nextPage() {
      if (this.offset + this.pageSize >= this.count) return
      this.offset += this.pageSize;
      this.find_mentors();
    },
    prevPage() {
      if (this.offset < this.pageSize) return
      this.offset -= this.pageSize;
      this.find_mentors();
    },
    find_mentors() {
      axios
        .get('/api/mentor/mentor/find_for_mentorship_public/', {
          params: {
            search: this.search_text,
            designation: this.selected_uid.designation,
            department: this.selected_uid.department,
            discipline: this.selected_uid.discipline,
            limit: this.pageSize, 
            offset: this.offset,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.search_results = response.data.results;
          this.count = response.data.count;

        })
        .catch((error) => {
          console.error(error);
          this.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
    },
    toggleContent(index) {
      this.search_results[index].isExpanded = !this.search_results[index].isExpanded;
    },
  },
};
</script>

<style scoped>
.search-results td,
.search-options td {
  border: none !important;
}
</style>
